import HelpDot from '@/components/ui/HelpDot';
import { cn } from '@/lib/utils';

/** Pane/section title with an optional explanation and a right-aligned slot. */
export default function SectionHeader({
  title,
  help,
  subtitle,
  right,
  className,
}: {
  title: React.ReactNode;
  /** Plain-language explanation of what this section is, shown in a tooltip. */
  help?: React.ReactNode;
  subtitle?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('mb-4', className)}>
      <div className="flex items-center gap-2.5">
        <h3 className="m-0 font-display text-lg font-semibold">{title}</h3>
        {help && <HelpDot>{help}</HelpDot>}
        {right && <div className="ml-auto flex items-center gap-2">{right}</div>}
      </div>
      {subtitle && <div className="mt-1 text-xs text-faint">{subtitle}</div>}
    </div>
  );
}
